import { ComponentStyleConfig } from '@chakra-ui/react'

export const Link = {
  baseStyle: {
    '&.active': {
      color: 'blueGray.50',
      fontWeight: 'semibold',
    },
  },
  variants: {
    highlighted: {
      '&.active': {
        color: 'blueGray.50',
      },
    },
    unhighlighted: {
      '&.active': {
        color: 'gray.525',
        fontWeight: 'regular',
      },
    },
    product: {
      borderBottomWidth: '1px',
      borderBottomColor: 'transparent',
      display: 'inline-block',
      _hover: {
        borderBottomColor: `currentColor`,
        textDecor: 'none',
      },
    },
    'product-global-nav-link': {
      borderBottomWidth: 3,
      fontWeight: 'semibold',
      fontSize: 'md',
      color: 'product.text.dark.buttonLink',
      px: 2,
      _hover: {
        textDecoration: 'none',
        color: 'product.text.dark.link',
        borderBottomWidth: 3,
        borderBottomColor: 'product.text.light.link',
        '.product-global-nav-link-right-icon': {
          color: 'product.text.dark.link',
        },
      },
      _focusVisible: {
        textDecoration: 'none',
        color: 'product.text.dark.link',
        borderBottomWidth: 3,
        borderBottomColor: 'product.text.light.link',
        '.product-global-nav-link-right-icon': {
          color: 'product.text.dark.link',
        },
      },
      _active: {
        color: 'product.text.dark.link',
        borderBottomWidth: 3,
        borderBottomColor: 'product.secondary',
        '.product-global-nav-link-right-icon': {
          color: 'product.text.dark.link',
        },
      },
    },
    'product-global-nav-link-active': {
      color: 'product.text.dark.link',
      borderBottomWidth: 3,
      borderBottomColor: 'product.secondary',
    },
    'product-lh-panel-link': {
      color: 'product.primary',
      fontSize: 'sm',
      _hover: {
        textDecoration: 'none',
        bg: 'product.gray.50',
      },
      _active: {
        bg: 'product.blue.100',
      },
    },
    'product-lh-panel-link-active': {
      borderLeftColor: 'product.secondary',
      bg: 'product.cyan.50',
      _hover: {
        textDecoration: 'none',
        bg: 'product.cyan.50',
      },
    },
  },
} satisfies ComponentStyleConfig
